import { fromTable } from '@/integrations/supabase/db';
import { SearchResult, SearchSectionId } from '../types';
import { getMatchFunction, getServerPattern, getServerLimit, calculateRelevanceScore } from '../utils';

export async function searchDownloadcenter(
  term: string, 
  limit: number, 
  exactMatch: boolean,
  fuzzyMatch: boolean = false,
  signal?: AbortSignal
): Promise<SearchResult[]> {
  if (!term.trim()) return [];
  
  const pattern = getServerPattern(term, fuzzyMatch);
  const serverLimit = getServerLimit(limit, fuzzyMatch);
  const matchFn = getMatchFunction(exactMatch, fuzzyMatch);
  
  const { data, error } = await fromTable('wissensdatenbank_dokumente')
    .select('id, bezeichnung, kategorie, file_type, gesellschaft_id, updated_at')
    .eq('status', 'aktiv')
    .or(`bezeichnung.ilike.${pattern},kategorie.ilike.${pattern}`)
    .limit(serverLimit);

  if (error) {
    console.error('Downloadcenter search error:', error);
    return [];
  }

  return (data || [])
    .filter(d => matchFn(term, d.bezeichnung, d.kategorie))
    .slice(0, limit)
    .map(d => {
      const title = d.bezeichnung || 'Dokument';
      const subtitle = d.kategorie || undefined;
      
      return {
        id: d.id,
        type: 'downloadcenter' as SearchSectionId,
        title,
        subtitle,
        badge: d.file_type || 'Dokument',
        data: d,
        relevanceScore: calculateRelevanceScore(term, title, subtitle, d.updated_at)
      };
    });
}
